<template>
  <div id="Expertthinkatnk" class="pub_pub">
    <div class="pub_title">
      <div class="img_logo">
        <img src="../imges/lebiao/zjzk.png" alt="" />
      </div>
      <div class="title_t">
        <div class="imhg_ti">
          <img src="../imges/lebiao/qkyda.png" alt="" />
        </div>
        <div class="sm_t">
          <div style="float:left">
            <span>直播</span><span style="color:#D7230C;">互动</span>
          </div>
          <div class="sm_pub">直播互动</div>
        </div>
      </div>
      <router-link tag="div" class="ckgd" to="/zbhddetail">
        查看更多&nbsp;>
      </router-link>
    </div>
    <div style="padding-left: 250px;position: relative;">
      <div style="position: absolute; top:18px;left:5px;">
        <div
          class="Exhtopleft"
          style="background-color: rgb(245, 78, 57);height: 190px;"
        >
          <div class="Exhtopleftimg">
            <img
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGYAAABgCAQAAABFj8/0AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkCRIQMChA1DMoAAACZElEQVR42u2bMWsUQRiGn2/Z3+BpENx0Sa2IyEVSpLkTTGklRMhVWlleY5XTxl8QJNjFH5CLhYUkV6iddYo7QZQttLH04LMQUWRJztzMfHPDPOUUM9+z8+7M7g4rANrhIVdpsYhMecsRj2UKAtrhALGuaU5qbshEtGJsXYkTRrImus9d6zocsVywbl2DM1aLBb3tm9gorCtwSZaJlaRkysbWZeuyzqRHf1YZZGJd7enohabWpGKWZWIly8RKlomVLBMrWeY01PDyuB/6mh5olYoMdDnRHTX4eOUnFCV9vmgnDRmAFkM9Dhs4v7drm7E+Cxc4/2vPo3CBC7GQBgtcqF2hzVh3fO9BIbe4Pp91KxUZaLGnx3o9DRmANu90V8v5O4pBBmCbT7rlfsm2eixssceR68BZvgI4D5z1+8w239ytcNYy8IE3acjUdLnl7ru2pcyAJTkUddehl/V+Bkbcc3/SYDEzNV1Z83FoEl5mwJIc+uk6bMyGPPB5jBVOpua+rxn5TZiYKQMu+VYJMzMv6cn3AON4lwkQrj/4jJkykIvhVPzNjPKEp2HC5VsmaLj8ynQtRLzIyHsbEbB+BcgyWWbxyDKxkmViJcvESlIyzc9mq7puXdgZrMwuM7Su9XwkFbMsEyuJydTWJTjjdcFz6xqc8VW04sTslMYlQ7ldyIQ7TK0rmZsRm/z6c1Yretx0PkBJu3FY15eu5gWvRPH5G7CW/GhoLlyeYv7TtT+Z8GSZWMkysZJlYiUpmXM8lWnJ5TlGvDLjnvnR3+b6t8yuhqD6/8qSilmWiZUsEytZJlayTKz8BAUa5Za2njhBAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIwLTExLTI1VDA4OjMyOjQyKzA4OjAwAQnCUAAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMC0wOS0xOFQwODo0ODo0MCswODowMO/E0ZEAAAAASUVORK5CYII="
              alt=""
              style="height: 100%; width: 100%;"
            />
          </div>
          <div class="Exhtitle">
            直播互动
          </div>
          <div style="overflow: hidden;margin-top: 20px;">
            <div
              @click="dialogVisible = true"
              class=""
              style="float:left;padding:4px 8px; border:1px solid #fff; color:#fff;font-size: 14px;margin-left: 30px;cursor: pointer;"
            >
              我要申请
            </div>
            <div
              class=""
              @click="fabu"
              style="float:left;padding:4px 8px; border:1px solid #fff; color:#fff;font-size: 14px;margin-left: 30px;cursor: pointer;"
            >
              我要发布
            </div>
          </div>
        </div>
      </div>
      <el-carousel
        style="margin-top: 10px;"
        :interval="5000"
        arrow="none"
        height="230px"
      >
        <el-carousel-item v-for="(item, index) in 2" :key="index">
          <div class="z_warp">
            <div
              @click="tza(o)"
              style="height: 190px;margin-top: 15px;box-shadow: rgb(0 0 0 / 16%) 0px 4px 24px;"
              class="lb_cont"
              v-for="(o, index) in xptjlist[index]"
              :key="index"
            >
              <div class="list_lb_img" style="height: 150px;">
                <img
                  v-lazy="'https://admin.shipoe360.com/public/' + o.picture"
                  alt=""
                />
              </div>
              <div class="xp_title" style="text-align: center;">
                {{ o.title }}
              </div>
              <!-- <div class="xp_title" style="text-align: center;font-size: 14px;">
                发布时间：{{ getLocalTime(o.create_time) }}
              </div> -->
              <!-- <div tag="div" class="ckxq_xp"
							>
							查看详情
						</div> -->
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <!-- <div class="modal">
      <div class="header">
        直播厅报名
      </div>
    </div> -->

    <el-dialog
      title="提示"
      custom-class="modal"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div slot="title">
        <div class="title">
          直播厅报名
        </div>
      </div>
      <span slot="footer" class="dialog-footer"> </span>
      <div style="overflow:hidden; padding-left: 100px;margin-bottom: 20px;;">
        <div class="lxfs_right_kf2" style="overflow:hidden ; float:left">
          <div class="lxfs_img___">
            <img
              src="data:image/png;base64,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"
              alt=""
            />
          </div>
          <div class="lxfs_text___1">
            <div class="kf">服务热线</div>
            <div class="jt">021-59145813</div>
          </div>
        </div>
        <div class="lxfs_right_kf3" style="overflow:hidden; float:left">
          <div class="lxfs_img___">
            <img
              src="data:image/png;base64,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"
              alt=""
            />
          </div>
          <div class="lxfs_text___1">
            <div class="kf">邮箱地址</div>
            <div class="jt">shipoe360@163.com</div>
          </div>
        </div>
      </div>
      <el-form ref="form" :model="form" label-width="120px" :rules="rules">
        <el-form-item label="联系人名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="单位名称" prop="dbname">
          <el-input v-model="form.dbname"></el-input>
        </el-form-item>
        <el-form-item label="职务" prop="zw">
          <el-input v-model="form.zw"></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input v-model="form.phone"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
        <div style="text-align:center">
          <el-button type="danger" @click="submitForm()">立即申请</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/utils/http";
export default {
  data() {
    return {
      xptjlist: "",
      dialogVisible: false,
      form: {
        name: "",
        dbname: "",
        zw: "",
        email: "",
        phone: "",
      },
      rules: {
        name: [
          { required: true, message: "请输入联系人名称", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱", trigger: "blur" }],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!/^1[3|4|5|6|7|8|9]{1}\d{9}$/.test(this.form.phone)) {
            return this.$message.error("请输入正确的手机号");
          } else if (
            !/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/.test(
              this.form.email
            )
          ) {
            return this.$message.error("请输入正确的邮箱");
          }
          const loginInfo = JSON.parse(
            window.sessionStorage.getItem("user") || null
          );

          http
            .post("api/picture/bmzb", {
              ...this.form,
              wid: loginInfo.id,
              zhanshi: "zbhd",
            })
            .then(() => {
              this.$message.success("申请成功");
              this.dialogVisible = false;
            });
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    tza(id) {
      console.log(id);
      window.open(id.url_link, "_blank");
    },
    fabu() {
      const loginInfo = JSON.parse(
        window.sessionStorage.getItem("token") || null
      );
      if (loginInfo == null) {
        this.$router.push({
          path: "/login",
        });
      } else {
        this.$router.push({
          path: "/user",
        });
      }
      http.post("api/picture/zbhd_index", {});
    },
    getLocalTime(nS) {
      return new Date(parseInt(nS) * 1000)
        .toLocaleDateString()
        .replace(/:\d{1,2}$/, " ");
    },
  },
  async mounted() {
    let res = await http.post("api/picture/zbhd_index", {});
    console.log(res);
    let xpList = res.data.data.list;
    let newArr = [[], []];
    xpList.forEach((item, index) => {
      if (index < 4) {
        newArr[0].push(item);
      } else if (index >= 4 && index < 8) {
        newArr[1].push(item);
      }
    });
    this.xptjlist = newArr;
  },
};
</script>

<style>
.modal .el-dialog__header {
  padding: 0;
}
.modal .el-dialog__body {
  /* padding: 0; */
}
.modal .title {
  background-color: #ff4400;
  color: #fff;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

#Expertthinkatnk {
  box-shadow: 10px 20px 10px -15px rgb(231, 231, 231);
}

/* 头部 */
#Expertthinkatnk .pub_pub {
  margin-top: 20px;
  border-radius: 0px !important;
}

#Expertthinkatnk .pub_title::after {
  content: "";
  display: block;
  clear: both;
}

#Expertthinkatnk .img_logo > img {
  width: 100%;
  height: 100%;
}

#Expertthinkatnk .img_logo {
  float: left;
  width: 36px;
  height: 36px;
  overflow: hidden;
}

#Expertthinkatnk .title_t {
  float: left;
  height: 36px;
  margin-left: 12px;
  font-weight: 600;
  letter-spacing: 3px;
}

#Expertthinkatnk .imhg_ti {
  height: 12px;
  width: 120px;
  margin-top: -5px;
}

#Expertthinkatnk .imhg_ti > img {
  width: 100%;
  height: 100%;
}

#Expertthinkatnk .sm_t {
  height: 26px;
  line-height: 26px;
  font-size: 18px;
  margin-top: 8px;
}

#Expertthinkatnk .sm_pub > ul::after {
  content: "";
  display: block;
  clear: both;
}

#Expertthinkatnk .sm_pub {
  float: left;
  margin-left: 40px;
  font-size: 12px;
  color: #5e5d5d;
  cursor: pointer;
}

#Expertthinkatnk .ct_title {
  float: left;
}

#Expertthinkatnk .ct_img {
  float: left;
  margin-left: 10px;
}

#Expertthinkatnk .ct_img > img {
  width: 12px;
  height: 10px;
}

#Expertthinkatnk .ckgd {
  float: right;
  margin-right: 20px;
  color: #999999;
  font-size: 15px;
  height: 36px;
  line-height: 46px;
  cursor: pointer;
}

/* 结尾 */

#Expertthinkatnk .z_warp::after {
  content: "";
  display: block;
  clear: both;
}

#Expertthinkatnk .lb_cont {
  float: left;
  width: calc((100% - 120px) / 4);
  margin-left: 24px;
  height: 230px;
  border: 1px solid #ececec;
}

#Expertthinkatnk .list_lb_img {
  height: 250px;
}

#Expertthinkatnk .list_lb_img > img {
  width: 100%;
  height: 100%;
}

#Expertthinkatnk .xp_title {
  height: 40;
  margin-left: 8px;
  font-size: 16px;
  font-weight: 600;
  margin-top: 12px;
  margin-bottom: 8px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

#Expertthinkatnk .ckxq_xp {
  width: 80px;
  border: 1px solid #ff4400;
  color: #ff4400;
  text-align: center;
  padding: 2px 0px;
  margin: 10px auto;
  cursor: pointer;
}

#Expertthinkatnk /deep/.el-carousel__container {
  height: 350px;
  margin-top: 20px;
}

.modal {
  /* position: fixed;
  top: 50%;
  left: 50%;
  background-color: #fff;
  width: 500px;
  height: 600px;
  border-radius: 8px;
  z-index: 99999;
  transform: translate(-50%, -50%); */
}
</style>
